import React, { useState, useEffect } from 'react';
import '../characterStyles.css';

const LuckPointCheckbox = ({ checked, value, label, onUnchecked }) => {
  const defaultChecked = checked ? checked : false;
  const [isChecked, setIsChecked] = useState(defaultChecked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  return (
    <div className="checkbox-wrapper">
      <label>
        <input
          className={isChecked ? 'checked' : ''}
          type="checkbox"
          checked={isChecked}
          onChange={() => {
            if (isChecked) onUnchecked(value);
          }}
        />
        {label}
      </label>
    </div>
  );
};

export default LuckPointCheckbox;
